var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    id: "figma",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M19.2 38.4a4.8 4.8 0 0 0 4.8-4.8v-4.8h-4.8a4.8 4.8 0 0 0 0 9.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M14.4 24a4.8 4.8 0 0 1 4.8-4.8H24v9.6h-4.8a4.8 4.8 0 0 1-4.8-4.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M14.4 14.4a4.8 4.8 0 0 1 4.8-4.8H24v9.6h-4.8a4.8 4.8 0 0 1-4.8-4.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M24 9.6h4.8a4.8 4.8 0 1 1 0 9.6H24V9.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M33.6 24a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.00a85202316962441a7951d875114d39.svg";
export { ForwardRef as ReactComponent };